import React from "react";
import {AuctionsManager} from "@nextlot/core/webcast";
import {RoundStopTypeEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";
import {Bid} from "@nextlot/core/webcast/data/data_types_definitions";
import {useAppSelector} from "@nextlot/core/webcast/hooks";
import classNames from "classnames";


type CmpPropsType = {
    currentRoundId: string,
    currentRoundHighestBid?: Bid
};



export default function ClerkRoundStopButtonsGroup(props:CmpPropsType) {
    const {
        currentRoundId,
        currentRoundHighestBid,
    } = props;

    const firstOnlineBid = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.firstOnlineBid);
    const highestBid = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.highestBid);
    const isHighestBidBelowMaxPrebid = firstOnlineBid?.userId !== highestBid?.userId && firstOnlineBid?.maximumValue >= highestBid?.value;


    const handleRoundStopButtonDblClick = (stopType) => (evt) => {
        AuctionsManager.currentWebcastAuctionHandler.controller.sendRoundStop(currentRoundId, stopType);
    };



    return (
        <div className="flex-grow-1 w-auto d-flex flex-row justify-content-between align-items-center">
            <div>
                <button className="btn btn-outline-secondary" type="button" onDoubleClick={handleRoundStopButtonDblClick(RoundStopTypeEnum.CANCEL)}>Cancel</button>
                <button className="ms-4 btn btn-warning" type="button" onDoubleClick={handleRoundStopButtonDblClick(RoundStopTypeEnum.NO_SALE)}>No Sale</button>

                {
                    currentRoundHighestBid &&
                    <button className="ms-4 btn btn-warning" type="button" onDoubleClick={handleRoundStopButtonDblClick(RoundStopTypeEnum.PENDING)}>Pending</button>
                }
            </div>

            {
                currentRoundHighestBid &&
                <div>
                    <button
                        className={classNames('ms-5 px-5 btn btn-lg', isHighestBidBelowMaxPrebid ? 'btn-outline-warning' : 'btn-success')} type="button"
                        onDoubleClick={handleRoundStopButtonDblClick(RoundStopTypeEnum.SOLD)}>&nbsp; SOLD! &nbsp;
                    </button>

                </div>
            }

        </div>
    );

};
